export function CustomDatePickerInput(props: React.HTMLProps<HTMLInputElement>, ref: React.Ref<HTMLInputElement>) {
  return <input type="text" placeholder="Data di nascita" {...props} className="form-input" ref={ref} />
}
